import * as React from "react";
import { useEffect, useState } from "react";
import api from "../../../utils/api_v2";
import LodingData from "../../../utils/LodingData";
import reservationStore from "../../../store/reservationStore";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import PhoneInTalkRoundedIcon from '@mui/icons-material/PhoneInTalkRounded';
import * as util from "../../../utils/util";
import img01 from "../../../assets/images/img01.jpg";
import { Button, Grid } from "@mui/material";
import Pagination from "react-js-pagination";

const hospitalParam = {
  cusId: '',
  famId: '',
  pageNum: 0,
  region: '',
  searchWord: ''
}

const SetHospital = (props: any) => {
  const storeData: any = reservationStore();
  const [hospitals, setHospitals] = useState([]); // 예약 가능한 병원
  const [hospitalsCount, setHospitalsCount] = useState(0); // 병원 목록 갯수
  const [regionList, setRegionList] = useState([]); // 병원 지역 목록
  const [selectedRegion, setSelectedRegion] = useState('all'); // 병원 지역 검색
  const [selectedWord, setSelectedWord] = useState(''); // 병원명 검색

  useEffect(() => {
    window.scrollTo(0, 0);
    hospitalParam.cusId = localStorage.getItem('userCusID') || '';
    hospitalParam.famId = decodeURIComponent(storeData.reservationInfo.famId);
    hospitalParam.pageNum = 0;
    hospitalParam.region = 'all';
    hospitalParam.searchWord = '';

    // 병원 및 지역 구분 목록
    LodingData(() => api.post('customer/api/v1/CU_003_002_1', hospitalParam).then(res => {
      setHospitals(res.data.hospitalList);
      setHospitalsCount(res.data.count);
      setRegionList(res.data.regionList);
    }).catch((error: any) => {
      console.log(error)
    }));

    return () => {
      storeData.setReservationInfo('date', '');
      storeData.setReservationInfo('time', '');
      storeData.setCloseItems([]);
      storeData.setReservationInfo('pkgId', '');
      storeData.setReservationInfo('addPrice', 0);
      storeData.setCheckedInjectioList([]);
      storeData.setChoiceLimitCount(0);
    }
  }, []);

  // 홈페이지 바로가기 버튼 활성화
  function hospitalCardUrlEnter(url: string) {
    if (!url.match(/^http?:\/\//i) || !url.match(/^https?:\/\//i)) {
      url = 'http://' + url;
    }
    window.open(url);
  }

  // 병원 선택 => 예약정보에 병원아이디 설정, 다음 스텝으로 이동
  function selectReservationHospital(hosId: string, target: any) {
    // target.closest('li').style.color = 'red';
    storeData.setReservationInfo('hosId', hosId);
    props.handleNext();
  }

  const handleChangeByRegion = (e: any) => {
    setSelectedRegion(e.target.value);
  };

  const handleChangeByWord = (e: any) => {
    setSelectedWord(e.target.value);
  };

  const handleSearchHospital = () => {
    hospitalParam.cusId = localStorage.getItem('userCusID') || '';
    hospitalParam.famId = decodeURIComponent(storeData.reservationInfo.famId);
    hospitalParam.pageNum = 0;
    hospitalParam.region = selectedRegion;
    hospitalParam.searchWord = selectedWord;

    LodingData(() => api.post('customer/api/v1/CU_003_002_1', hospitalParam).then(res => {
      setHospitals(res.data.hospitalList);
      setHospitalsCount(res.data.count);
      setRegionList(res.data.regionList);
    }).catch((error: any) => {
      console.log(error)
    }));
  };


  const handleEnter = (e: any) => {
    if (e.key === 'Enter') {
      handleSearchHospital();
    }
  }

  const handleHover = (e: any) => {
    $(e.target).children('.layer').css('display', 'block');
  }

  const handleLeave = () => {
    $('.layer').css('display', 'none');
  }

  const handlePageChange = (page: number) => {
    hospitalParam.cusId = localStorage.getItem('userCusID') || '';
    hospitalParam.famId = decodeURIComponent(storeData.reservationInfo.famId);
    hospitalParam.pageNum = page - 1;
    hospitalParam.region = selectedRegion;
    hospitalParam.searchWord = selectedWord;

    LodingData(() => api.post('customer/api/v1/CU_003_002_1', hospitalParam).then(res => {
      setHospitals(res.data.hospitalList);
      setHospitalsCount(res.data.count);
      setRegionList(res.data.regionList);
    }).catch((error: any) => {
      console.log(error)
    }));
  }


  return (

    <Container maxWidth="xl" sx={{ p: '0 20px 70px 20px' }}>
      {/*<Box sx={{ bgcolor: '#FFFBF8', height: '100px',}} >
        <Stack direction="row"  spacing={1} sx={ChipStyle}>
          <Chip label="대전 유성구" onClick={handleClick} className="chipOn"/>
          <Chip label="거리순"  onClick={handleClick} />
          <Chip label="종합검진" onClick={handleClick} />
          <Chip label="최저가" variant="outlined" onClick={handleClick} />
          <Chip label="국가검진" variant="outlined" onClick={handleClick} />
          <Chip label="건강검진" variant="outlined" onClick={handleClick} />
          <Chip label="1515건강검진" variant="outlined" onClick={handleClick} />
        </Stack>

        <Typography sx={{ display: 'flex', fontSize:'14px', m:1 }}>
          병원검색
        </Typography>
      </Box>*/}

      <Paper component="form" sx={search_Fome_Style}>
        <Box sx={{ minWidth: 100, borderRight: '1px solid #ddd' }}>
          <FormControl fullWidth sx={{
            '& .MuiOutlinedInput-notchedOutline': { border: 'none' }
          }}>
            {/*  <InputLabel id="demo-simple-select-label">지역</InputLabel> */}
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="지역"
              defaultValue="all"
              onChange={handleChangeByRegion}
              sx={{ border: 'none' }}
            >
              <MenuItem value="all">전체</MenuItem>
              {regionList.map((rg: any, index: any) => (
                <MenuItem value={rg}>{rg}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        <InputBase
          sx={{ ml: 1, flex: 1, }}
          placeholder="병원명을 입력하세요(2자 이상)"
          inputProps={{ 'aria-label': '병원명을 입력하세요' }}
          onChange={handleChangeByWord}
          onKeyDown={handleEnter}
        />
        <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
          <SearchIcon onClick={handleSearchHospital} />
        </IconButton>
      </Paper>

      <Box sx={{}}>
        <Typography>병원 검색</Typography>
        <List sx={{ m: '10px auto', display: "flex", flexWrap: 'wrap', justifyContent: 'space-between', }}>
          {hospitals.length === 0 ? (
            <Box>
              <Typography sx={{ fontSize: 16, color: '#888' }} >예약 가능한 병원이 없습니다.</Typography>
            </Box>
          ) : hospitals && hospitals.map((hospital, index) => (
            <ListItem key={index} alignItems="flex-start" sx={Card_Style} >
              <ListItemAvatar >
                {/*
                  <Avatar
                    alt=""
                    src={util.strNull(hospital['hosImage']) !== '' ? hospital['hosImage'] : img01}
                    sx={cardBox1}
                    onClick={() => hospitalCardUrlEnter(hospital['hosURL'])}
                    onMouseOver={handleHover}
                    onMouseLeave={handleLeave}
                  />
                */}
                <Box sx={{ position: 'relative' }} onMouseOver={handleHover} onMouseLeave={handleLeave}>
                  <Box
                    sx={{
                      backgroundImage: `url(${util.strNull(hospital['hosImage']) !== '' ? hospital['hosImage'] : img01})`,
                      backgroundSize: 'cover',
                      borderRadius: 3,
                      width: '150px',
                      height: '150px',
                      cursor: 'pointer',
                    }}
                    onClick={() => hospitalCardUrlEnter(hospital['hosURL'])}
                  >
                    <Typography sx={cardBox} className="layer">
                      <span style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>홈페이지 바로가기</span>
                    </Typography>
                  </Box>
                </Box>
              </ListItemAvatar>
              <ListItemText sx={{ pl: 2, cursor: 'default' }}
                primary={hospital['hosName']}
                secondary={
                  <React.Fragment>
                    <Typography
                      sx={{ display: 'inline', }}
                      component="span"
                      variant="body2"
                      color="text.primary"
                    >
                      {hospital['hosAddress']}
                    </Typography>
                    <Typography
                      sx={{ display: 'inline' }}
                      component="span"
                      variant="body2"
                      color="text.primary"
                    >
                    </Typography>
                    <Stack direction="row" spacing={1} sx={CardChipStyle}>
                      {/* <Chip icon={<StarRoundedIcon sx={{color:'#fbb001 !important'}} />}  label={hospital['totalPoint'] } size="small" sx={{bgcolor:'#fff'}} /> */}
                      <Chip icon={<PhoneInTalkRoundedIcon sx={{ color: '#888 !important' }} />} label={hospital['hosPhone']} size="small" sx={{ bgcolor: '#fff' }} />
                    </Stack>
                    <Button variant="outlined" sx={{ border: '1px solid #0d6703', borderRadius: 20, color: '#0d6703', mt: 3.5, '&:hover': { background: '#0d670312', border: '1px solid #0d6703' } }} onClick={(e) => selectReservationHospital(hospital['hosId'], e.target)}>예약하기</Button>
                  </React.Fragment>
                }
              />
            </ListItem>
          ))}
        </List>
      </Box>

      <Grid container className='foot_list'>
        <Pagination
          activePage={hospitalParam.pageNum + 1} // 현재 페이지
          itemsCountPerPage={6} // 한 페이지에 보여줄 아이템 갯수
          totalItemsCount={hospitalsCount} // 총 아이템 갯수
          pageRangeDisplayed={10} // paginator의 페이지 범위
          prevPageText={"‹"} // "이전"을 나타낼 텍스트
          nextPageText={"›"} // "다음"을 나타낼 텍스트
          onChange={handlePageChange} // 페이지 변경을 핸들링하는 함수
        />
      </Grid>

    </Container>
  );
}

const search_Fome_Style = {
  m: '30px auto 20px auto',
  p: '2px 4px',
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  borderRadius: '20px',
  boxShadow: 'inset 0 0 4px rgba(0,0,0,0.4)',
  boxSizing: 'border-box'
};

const Card_Style = {
  borderRadius: '20px',
  background: '#fff',
  boxShadow: '0 0 6px  rgba(0,0,0,0.2)',
  marginBottom: '20px',
  width: '49%'
};

const ChipStyle = {
  maxWidth: 460,
  overflow: 'auto',
  whiteSpace: 'nowrap',
  p: 2
};

const CardChipStyle = {
  maxWidth: 460,
  overflow: 'auto',
  whiteSpace: 'nowrap',
  p: 1,
  pl: 0
};

const cardBox = {
  width: '100%',
  height: '100%',
  borderRadius: 3,
  display: 'none',
  position: 'relative',
  color: 'white',
  backgroundColor: 'rgba(0, 0, 0, 0.4)',
  textAlign: 'center',
}

export default SetHospital;

